import { modalActions } from "../../../../../../../../../context/actions/modalActions";
import useStore from "../../../../../../../../../context/useStore";
import { useState } from "react";
import SaveBtn from "../../../../../../../../common/SaveBtn";

const DERForm = ({
  actions,
  company,
  getDenominationClient,
  documentState,
}) => {
  const [state, dispatch] = useStore();
  const modal_actions = modalActions(state, dispatch);

  const [derDate, setDerDate] = useState("");
  const [denominationClient, setDenominationClient] = useState(
    getDenominationClient(),
  );

  const handleGenerate = () => {
    actions.generateDER(company.id, denominationClient, derDate);
    modal_actions.updateModal({
      isOpen: false,
      content: null,
    });
  };

  return (
    <div>
      <div className="form-group">
        <label>Client - société</label>
        <input
          type="text"
          className="form-control"
          value={denominationClient}
          onChange={(e) => setDenominationClient(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Date</label>
        <input
          type="date"
          className="form-control"
          value={derDate}
          onChange={(e) => setDerDate(e.target.value)}
        />
      </div>
      <div
        className="form-group d-flex justify-content-end mb-0"
        style={{ gap: "10px" }}
      >
        <button
          type="button"
          className="btn btn-default"
          onClick={() => {
            modal_actions.updateModal({
              isOpen: false,
              content: null,
            });
          }}
        >
          Annuler
        </button>
        <SaveBtn
          save={handleGenerate}
          isSaving={documentState.isGeneratingDER}
          text={
            <>
              <i className="fa fa-file-text-o mr-2" />
              Générer
            </>
          }
          type="primary"
          loaderColor="#ffffff"
          loadingText="Génération en cours..."
        />
      </div>
    </div>
  );
};

export default DERForm;
